// @ts-strict-ignore
import { LMProcessIndicatorService } from '../../field/processindicator/lm-process-indicator.service';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace lmProcessIndicatorFormatter {
  export const format = (
    processIndicatorService: LMProcessIndicatorService,
    row: number,
    cell: number,
    value: any,
    columnDef: ListGridColumn,
    dataView: LMListDataView
  ): string => {
    const processIndicatorData: LMProcessIndicatorData = processIndicatorService.formatProcessIndicatorData(dataView, columnDef);
    const templateData = processIndicatorService.getTemplateData(processIndicatorData);

    return getProcessIndicatorHTML(templateData);
  };

  export const getProcessIndicatorHTML = (templateData: Array<LMProcessIndicatorDisplayData>): string => `
      <div class="process-indicator compact responsive has-labels" style="display: block; width: 100%;">
        <div class="display">
          ${templateData.map((data, i) => `
              <div class="step" id="step${data.stepId}">
                <div class="lines">
                    ${getIndicatorHTML(data)}
                    <span class="${getSeparatorClasses(data)}"></span>
                </div>
              </div>
            `).join('')}
        </div>
    </div>`;

  export const getSeparatorClasses = (data: LMProcessIndicatorDisplayData): string => {
    const cssClasses = ['separator'];

    if (data.status === 'C' || data.status === 'X') {
      cssClasses.push('darker');
    }

    return cssClasses.join(' ');
  }

  export const getIndicatorClasses = (data: LMProcessIndicatorDisplayData): string => {
    const cssClasses = ['indicator'];

    if (data.completionStatusInfo.indicatorClass) {
      cssClasses.push(data.completionStatusInfo.indicatorClass);
    }

    if (data.completionStatusInfo.iconInfo.icon) {
      cssClasses.push('icon');
    }

    return cssClasses.join(' ');
  }

  export const getIndicatorHTML = (data: LMProcessIndicatorDisplayData): string => `
    <div class="${getIndicatorClasses(data)}">
        ${data.completionStatusInfo.iconInfo.icon ? `
        <svg class="icon ${data.completionStatusInfo.iconInfo.icon} ${data.completionStatusInfo.iconInfo.colorClass}" focusable="false" aria-hidden="true" role="presentation">
            <use xlink:href="#icon-${data.completionStatusInfo.iconInfo.icon}"></use>
        </svg>` : ''}
      </div>
    `;
}
